import { CalendarCheck, Droplets, Hand } from "lucide-react";
import { Reveal } from "./Reveal";
import { useLang } from "../i18n/LangContext";

const ICONS = [Droplets, Hand, CalendarCheck];

const CareTips = () => {
    const { t } = useLang();
    return (
    <section data-testid="care-tips-section" className="wine-noir py-24 sm:py-28">
        <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12">
            <div className="max-w-2xl">
                <Reveal>
                    <p className="font-mono text-xs uppercase tracking-[0.35em] text-gold">
                        {t.careTips.eyebrow}
                    </p>
                </Reveal>
                <Reveal delay={0.12}>
                    <h2 className="mt-5 font-serif text-3xl leading-[1.08] tracking-tight text-cream sm:text-5xl">
                        {t.careTips.titleA} <span className="italic text-gold">{t.careTips.titleB}</span>
                    </h2>
                </Reveal>
            </div>

            <div className="mt-14 grid gap-6 md:grid-cols-3 lg:gap-8">
                {t.careTips.tips.map((tip, i) => {
                    const Icon = ICONS[i];
                    return (
                        <Reveal key={tip.title} delay={i * 0.14}>
                            <div
                                data-testid={`care-tip-${i}`}
                                className="group h-full rounded-3xl border border-burnt/20 bg-espresso/30 p-8 transition-all duration-500 hover:-translate-y-1.5 hover:border-gold/40"
                            >
                                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-gold/15 transition-colors duration-500 group-hover:bg-gold/25">
                                    <Icon className="h-5 w-5 text-gold" />
                                </div>
                                <h3 className="mt-6 font-serif text-xl text-cream sm:text-2xl">
                                    {tip.title}
                                </h3>
                                <p className="mt-3 text-sm leading-relaxed text-taupe">
                                    {tip.text}
                                </p>
                            </div>
                        </Reveal>
                    );
                })}
            </div>
        </div>
    </section>
    );
};

export default CareTips;
